import React from "react";
import Label from "../../UI/Label";
import Button from "../../UI/Button";
import { postAxios, putAxios } from "../../../Services/commonService";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { API_WHITELABEL } from "../../../../utils/api/ApiConstant";
import Error from "../../UI/Error";
import { WhitelabelSchema } from "../../../Schema/Configuration/WhitelabelSchema";
import { lowerFirstLetterUsingRegex } from "../../../helper/common";
import { sanitizeNameInput } from "../../../../utils/inputUtils";

const WhiteLabelModal = ({ handleModalHide, rowData, fetchData }) => {
  const isEdit = !!rowData.id;

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      name: rowData?.name ?? "",
      apiURL: rowData?.apiURL ?? "",
      socketURL: rowData?.socketURL ?? "",
      webURL: rowData?.webURL ?? "",
    },
    resolver: yupResolver(WhitelabelSchema),
  });

  const handleFormSubmit = async (payload) => {
    let res;
    if (isEdit) {
      const updatePayload = {
        name: payload?.name,
        apiURL: payload?.apiURL,
        socketURL: payload?.socketURL,
        webURL: payload?.webURL,
        isActive: rowData?.isActive,
        rowVersion: rowData?.rowVersion,
      };
      res = await putAxios(`${API_WHITELABEL}/${rowData?.id}`, updatePayload);
    } else {
      res = await postAxios(API_WHITELABEL, payload);
    }
    if (res?.success) {
      fetchData();
      handleModalHide();
    }
    res?.errors?.forEach((element) => {
      const field = lowerFirstLetterUsingRegex(element?.field);
      if (field)
        setError(field, {
          type: "manual",
          message: element.message,
        });
    });
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <fieldset disabled={isSubmitting}>
        <div className="row ">
          <div className="col-lg-12 col-12">
            <div className="form-group">
              <Label htmlFor="name" className="form-label" isRequired={true}>
                Name
              </Label>
              <input
                className="form-control"
                type="text"
                id="name"
                placeholder="Enter name"
                autoFocus={true}
                tabIndex={1}
                {...register("name", {
                  onChange: (e) => {
                    e.target.value = sanitizeNameInput(e.target.value);
                  },
                })}
              />
              {errors.name && <Error>{errors.name.message}</Error>}
            </div>
          </div>
          <div className="col-lg-12 col-12">
            <div className="form-group">
              <Label htmlFor="apiURL" className="form-label">
                Api URL
              </Label>
              <input
                className="form-control"
                type="text"
                id="apiURL"
                placeholder="Enter Api URL"
                {...register("apiURL")}
                tabIndex={2}
              />
              {errors.apiURL && <Error>{errors.apiURL.message}</Error>}
            </div>
          </div>
          <div className="col-lg-12 col-12">
            <div className="form-group">
              <Label htmlFor="socketURL" className="form-label">
                Socket URL
              </Label>
              <input
                className="form-control"
                type="text"
                id="socketURL"
                placeholder="Enter Socket URL"
                {...register("socketURL")}
                tabIndex={3}
              />
              {errors.socketURL && <Error>{errors.socketURL.message}</Error>}
            </div>
          </div>
          <div className="col-lg-12 col-12">
            <div className="form-group">
              <Label htmlFor="webURL" className="form-label">
                Web URL
              </Label>
              <input
                className="form-control"
                type="text"
                id="webURL"
                placeholder="Enter Web URL"
                {...register("webURL")}
                tabIndex={4}
              />
              {errors.webURL && <Error>{errors.webURL.message}</Error>}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end w-100 mt-3">
          <Button
            type="button"
            className="btn btn_main btn_muted px-3 py-2 mx-1"
            onClick={handleModalHide}
            tabIndex={6}
          >
            Close
          </Button>
          <Button
            type="submit"
            className="btn btn_main px-3 py-2 mx-1"
            tabIndex={5}
            isDisabled={isSubmitting}
          >
            {isSubmitting ? "Loading.." : isEdit ? "Update" : "Create"}
          </Button>
        </div>
      </fieldset>
    </form>
  );
};

export default WhiteLabelModal;
